module.exports = __webpack_public_path__ + "img/horizontal_4_7_8017.9a1d4f80.png";